import { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  IconButton,
  InputAdornment
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const FRONTEND_LOGIN_USER_KEY = "frontend_login_username";
const FRONTEND_LOGIN_PASSWORD_KEY = "frontend_login_password";
const DEFAULT_FRONTEND_USERNAME = "brokancode";
const DEFAULT_FRONTEND_PASSWORD = "pharmaron2025";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const correctUser =
    localStorage.getItem(FRONTEND_LOGIN_USER_KEY) || DEFAULT_FRONTEND_USERNAME;
  const correctPass =
    localStorage.getItem(FRONTEND_LOGIN_PASSWORD_KEY) || DEFAULT_FRONTEND_PASSWORD;

  const attemptLogin = () => {
    if (username === correctUser && password === correctPass) {
      localStorage.setItem("lead_auth", "true");
      onLogin();
    } else {
      setError("Incorrect username or password");
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f0f2f5"
      }}
    >
      <Paper sx={{ padding: 4, width: 350, textAlign: "center" }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
          Login
        </Typography>

        <TextField
          label="Username"
          fullWidth
          sx={{ mb: 2 }}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <TextField
          label="Password"
          type={showPassword ? "text" : "password"}
          fullWidth
          sx={{ mb: 2 }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword((p) => !p)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />

        {error && (
          <Typography color="error" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}

        <Button variant="contained" fullWidth onClick={attemptLogin}>
          Login
        </Button>
      </Paper>
    </Box>
  );
}
